import { useState, useContext } from 'react';
import AuthContext from '../../../contexts/AuthContext';
import { ACM } from '../../../constants/UserRoles';

const useUploadFormState = (user, typeOfUser) => {
  const { openVideoUpload, setOpenVideoUpload } = useContext(AuthContext);
  
  // File and basic form state
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileDuration, setFileDuration] = useState(0);
  const [customFileName, setCustomFileName] = useState('');
  const [date, setDate] = useState(null);
  const [information, setInformation] = useState({ notes: '' });
  
  // Selection state
  const [selectedStudent, setSelectedStudent] = useState(
    ACM[typeOfUser]?.isStudent ? user?.uid : ''
  );
  const [selectedPatient, setSelectedPatient] = useState(
    ACM[typeOfUser]?.isPatient ? user?.uid : ''
  );
  const [newStudent, setNewStudent] = useState(
    ACM[typeOfUser]?.isStudent ? user?.uid : null
  );
  const [newPatient, setNewPatient] = useState(
    ACM[typeOfUser]?.isPatient ? user?.uid : null
  );
  
  // Behavior and goal state
  const [goalAssociatedWithBehavior, setGoalAssociatedWithBehavior] = useState(false);
  const [selectedGoalIds, setSelectedGoalIds] = useState([]);
  const [selectedBehaviorIds, setSelectedBehaviorIds] = useState([]);
  const [selectedSkillIds, setSelectedSkillIds] = useState([]);
  const [otherInputValue, setOtherInputValue] = useState('');
  const [selectCategory, setSelectCategory] = useState('None');
  
  // Therapy and intervention state
  const [therapyType, setTherapyType] = useState('');
  const [interventions, setInterventions] = useState('');
  const [antecedent, setAntecedent] = useState('');
  const [consequence, setConsequence] = useState('');
  
  // Sharing and privacy state
  const [editAndViewIds, setEditAndViewIds] = useState([]);
  const [viewOnlyIds, setViewOnlyIds] = useState([]);
  const [videoFeedBackNotesPrivate, setVideoFeedBackNotesPrivate] = useState(false);
  
  return {
    // File and basic form state
    uploadedFile,
    setUploadedFile,
    fileDuration,
    setFileDuration,
    customFileName,
    setCustomFileName,
    date,
    setDate,
    information,
    setInformation,
    
    // Selection state
    selectedStudent,
    setSelectedStudent,
    selectedPatient,
    setSelectedPatient,
    newStudent,
    setNewStudent,
    newPatient,
    setNewPatient,
    
    // Behavior and goal state
    goalAssociatedWithBehavior,
    setGoalAssociatedWithBehavior,
    selectedGoalIds,
    setSelectedGoalIds,
    selectedBehaviorIds,
    setSelectedBehaviorIds,
    selectedSkillIds,
    setSelectedSkillIds,
    otherInputValue,
    setOtherInputValue,
    selectCategory,
    setSelectCategory,
    
    // Therapy and intervention state
    therapyType,
    setTherapyType,
    interventions,
    setInterventions,
    antecedent,
    setAntecedent,
    consequence,
    setConsequence,
    
    // Sharing and privacy state
    editAndViewIds,
    setEditAndViewIds,
    viewOnlyIds,
    setViewOnlyIds,
    videoFeedBackNotesPrivate,
    setVideoFeedBackNotesPrivate,
    
    // Dialog state
    openVideoUpload,
    setOpenVideoUpload,
  };
};

export default useUploadFormState;
